import Underline from '@components/Underline';
import { Column } from '@components/LinearLayout';
import { Wrapper, ContentContainer, Title, Paragraph } from './styles';
import { useMobileWidth } from '@utils/hooks';
export interface ParagraphItem {
  content: string;
  moreContent?: string[];
}

export interface MiddleTextWithUnderlineProps {
  title: string;
  underlineColor: string;
  paragraphs: ParagraphItem[];
  isSpecialPage?: boolean;
  align?: 'left' | 'center';
}

const MiddleTextWithUnderline = ({
  title,
  underlineColor,
  paragraphs,
  isSpecialPage,
  align = 'center',
}: MiddleTextWithUnderlineProps) => {
  const isMobile = useMobileWidth();
    return (
    <Wrapper>
      <ContentContainer $isSpecialPage={isSpecialPage} $align={align}>
        <Column $gap="1.7rem">
          <Title $isSpecialPage={isSpecialPage} $align={align}>
            {title}
          </Title>

          {/* underline vizibil și pe mobil */}
          <div
            style={{
              display: 'flex',
              justifyContent: align === 'left' ? 'flex-start' : 'center',
            }}
          >
            <Underline
              width={isMobile ? '10rem' : '16.3rem'}
              color={underlineColor}
            />
          </div>

          {paragraphs.map((paragraph, index) => (
            <Paragraph key={`paragraph-${index}`} $align={align}>
              {paragraph.content}
              {paragraph.moreContent?.map((content, i) => (
                <span key={`moreContent-${i}`}>
                  {!isMobile && <br />}
                  {isMobile && ' '}
                  {content}
                </span>
              ))}
            </Paragraph>
          ))}
        </Column>
      </ContentContainer>
    </Wrapper>
  );
};

export default MiddleTextWithUnderline;
